import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-iteration-loader',
  templateUrl: './chat-iteration-loader.component.html',
  styleUrls: ['./chat-iteration-loader.component.scss']
})

export class ChatIterationLoaderComponent implements OnInit {

  @Input() iteration: number = 0;
  checkpoints = Array.from({ length: 10 }, (_, i) => i + 1);
  constructor() { }

  ngOnInit(): void {
  }

  get segments(): Array<number> {
    return Array.from({ length: 10 }, (_, i) => i + 1);
  }
}
